import { Stack, Typography } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { SignalHigh, SignalMedium } from 'lucide-react'
import { InventoryAlertSeverity } from 'pbts/c1/api/inventory/v1/inventory_alerts'
import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

export const InventoryAlertStrength = ({ severity }: { severity: InventoryAlertSeverity }): ReactElement => {
    return <Stack direction="row" alignItems="center" gap={1}>
        {getSeverity(severity)}
    </Stack>
}

const getSeverity = (severity: InventoryAlertSeverity): ReactElement => {
    switch (severity) {
        case InventoryAlertSeverity.LOW:
            return <>
                <C1Icon icon={SignalMedium} sx={{ color: 'primary.main' }} />
                <Typography>
                    <FormattedMessage id="components_inventory_alerts_warning" defaultMessage="Low" />
                </Typography>
            </>
        case InventoryAlertSeverity.MEDIUM:
            return <>
                <C1Icon icon={SignalHigh} sx={{ color: 'warning.main' }} />
                <Typography>
                    <FormattedMessage id="components_inventory_alerts_warning" defaultMessage="High" />
                </Typography>
            </>
        case InventoryAlertSeverity.HIGH:
            return <>
                <C1Icon icon={SignalHigh} sx={{ color: 'error.main' }} />
                <Typography>
                    <FormattedMessage id="components_inventory_alerts_warning" defaultMessage="Critical" />
                </Typography>
            </>
        default:
            return <C1Icon icon={SignalHigh} sx={{ color: 'action.disabled' }} />
    }
}
